import { BottomSheet, Flex, Image, Shape, styled } from '@teko/ds-mobile';
import { MODE_TERMINAL_PICKER, useDistanceTerminalContext } from 'contexts';
import { t } from 'i18n';
import React from 'react';
import { PopupTerminalPickerProps } from '..';
import TerminalPicker from '../../../../assets/terminal-picker.png';
import { ModeEnterAddress } from './ModeEnterAddress';
import { ModeListAddress } from './ModeListAddress';
import { ModeListTerminal } from './ModeListTerminal';

export const PopupTerminalPickerMobile: React.FC<PopupTerminalPickerProps> = ({
  showPopup,
  onClosePopup,
}) => {
  const { modeTerminalPicker, currentTerminal } = useDistanceTerminalContext();

  if (showPopup && modeTerminalPicker === MODE_TERMINAL_PICKER.ENTER_ADDRESS) {
    return (
      <FullScreenWrapper>
        <ModeEnterAddress />
      </FullScreenWrapper>
    );
  }

  return (
    <StyledBottomSheet
      show={showPopup}
      position={'bottom'}
      zIndex={2000}
      closeBottomSheet={currentTerminal ? onClosePopup : undefined}
      contentHeight="78vh"
      title={t('Chọn khu vực của bạn')}
    >
      <Flex
        padding="s16"
        direction="column"
        gap="s12"
        align="center"
        justify="center"
      >
        {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_TERMINAL && (
          <>
            <Shape paddingBottom="s16">
              <Image
                height="72px"
                width="116px"
                src={TerminalPicker}
                alt={t('Chọn khu vực của bạn')}
              />
            </Shape>
            <ModeListTerminal />
          </>
        )}
        {modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_ADDRESS && (
          <ModeListAddress />
        )}
      </Flex>
    </StyledBottomSheet>
  );
};

const StyledBottomSheet = styled(BottomSheet)`
  width: 100%;
`;

const FullScreenWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
`;
